import { filter } from 'rxjs/operators';
/*
 * spurtcommerce
 * version 4.3
 * http://api.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { AfterViewChecked, AfterViewInit, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Component, OnDestroy, OnInit, ViewChild, VERSION, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { ProductZoomComponent } from './product-zoom/product-zoom.component';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { ConfigService } from '../../../../core/service/config.service';
import { Observable, Subscription } from 'rxjs';
import { ProductControlSandbox } from '../../../../core/product-control/product-control.sandbox';
import { MatDialog } from '@angular/material/dialog';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { ViewTierpriceChartComponent } from '../modal/view-tierprice-chart/view-tierprice-chart.component';
import { MakeQuatationComponent } from '../modal/make-quatation/make-quatation.component';
import { element } from 'protractor';

import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
// import { Observable } from 'rxjs';
//  import {  ProductFileUploadService } from '../../../../core/service/productfile-upload.service';

// import pdfMake from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const FileSaver = require('file-saver');
import { SeoService } from '../../../pages/products/seo.service';


import { environment } from 'src/environments/environment';
import { convertActionBinding } from '@angular/compiler/src/compiler_util/expression_converter';
import { ReviewPopupComponent } from 'src/default/shared/components/review-popup/review-popup.component';
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})

export class ProductComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  // decorator
  @ViewChild('zoomViewer') zoomViewer;
  @ViewChild(SwiperDirective) directiveRef: SwiperDirective;
  @ViewChild('techSpec') techSpec: ElementRef;
  // public url=environment.storeUrl + 'product-store/download-pdf'
  // @ViewChild('pdfTable')
  // pdfTable!: ElementRef;
  divHeight: string = '200px'; // Initial height
  buttonText: string = '>> More';
  public share = window.location.href;
  currentDate: Date = new Date();
  name = 'Angular ' + VERSION.major;
  public video_url = "http://157.230.179.86:5000";
  public video = '';
  // configuration
  public config: SwiperConfigInterface = {};
  public configuration: SwiperConfigInterface = {};
  public product: any;
  // images
  public image: any;
  public zoomImage: any;
  public zoomPopupImage: any;
  public imagePath: string;
  public productImageId: number;
  // related product data
  public relatedProducts: Array<any>;
  // route params
  private sub: any;
  private id: any;
  public radioValue: any = 'jh';
  public totalPrice = 0;
  public removeData = [];
  public removePrefix = [];
  private previousData = [];
  private previousPrefix = [];
  private temptotalPrice: number;
  // available options
  public optionNameSelected: any = [];
  public cartOptionValueArray: any = [];
  public optionNames: any = [];
  public optionValueArray: any = [];
  public previousValueRadio = '';
  public previousValueDropdown = [];
  public oneTimePush = 'enter';
  public oneTimePushValue = 'enter';
  public deleteArray = false;
  public modeSelect = [];
  public totalProductPrice: number;
  public productPriceTag: number;
  public previousPriceTag: number;
  public tempPriceRefer: number;
  public templateHidden: number;
  public productDetails: any = {};
  productId: any;
  pinCode: any;
  searchTerm:any;
  checkPinCode = false;
  pinCodeError = false;
  // subcription
  private subscriptions: Array<Subscription> = [];
  isActive = [];
  public user: any;
  public pincodeBasedDelivery = 0;
  public tireBasePrice: any;
  public currentUser: any;
  public isPreviewOpen: boolean;


  // default quantity for count change
  public quantity: any = 1;
  public currentVarientIndex = 0;

  // tire price
  public tireQuantityArray: any = [];
  public tirePrice: any = '';
  public currency: any;

  // pushed option value id in this array(unique id)
  public selectedOptions: any = [];
  public selectedOptionsName: any = [];

  public variantDetails = [];
  productRating=[];
  ratingArray: any[];
  filteredReviews: any;
  hideMoreButton: boolean = false;
  fullProductCache:any;
  splecialDealValue: string;
  imageArray: any;
  ProductRating: any;
  previewImageSrc: string;
  isPreviewOpenproduct: boolean;
  currentIndex: number;
  productlength: any;
  previw_image: string;
  product_image: any;
  imagesproduct: any;
  currentImageIndexproduft: number;
  containerName: any;
  // private fileName;

  // currentFile?: File;
  // progress = 0;
  // message = '';

  // fileName = 'Select File';
  // fileInfos?: Observable<any>;

  // public formGroup = this.fb.group({
  //   file: [null, Validators.required]
  // });

  // public displayLoader: Observable<boolean> = this.uploadService.isLoading();

  constructor(
    private activatedRoute: ActivatedRoute,
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    public productDetail: ListsSandbox,
    public productControlSandbox: ProductControlSandbox,
    private configService: ConfigService,
    private changeDetectRef: ChangeDetectorRef,
    private router: Router,
    private metaService: Meta,
    public seoService:SeoService,
    public http:HttpClient,
    private el: ElementRef,
    private renderer: Renderer2,
    
    // private uploadService: ProductFileUploadService,
    // private fb: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object
    ) {
      this.splecialDealValue = localStorage.getItem('specialdeal')
      console.log("===========================================================================================specialdeallllll",this.splecialDealValue)

    this.getProductdetail();

    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = true;
        window.scrollTo(0, 0);
      }
    });
    // pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }
  ngAfterViewChecked(): void {

    const element = document.getElementById('techSpec'); // Replace with the actual element ID
    const divElement = document.getElementById('quickSpec')
    if(divElement){
      this.calculateDivHeight();
    }
    if (element) {
      this.applyElementStyle();
      
    }
    
  }


  /** Initially initialize getProductdetail,getRelatedProducts when subscribed
   * subscribe productDetails$ and set initially default values for required options **/
  ngOnInit() {

    if(this.id != undefined){
      this.getProductdetail();
      
    }
    

    this.currency = JSON.parse(localStorage.getItem('currency'));
    if (isPlatformBrowser(this.platformId)) {
      this.user = JSON.parse(localStorage.getItem('storeUser'));
    }

    this.imagePath = this.configService.getImageUrl();
    console.log('imagePath',this.imagePath)
    // subscribe route params and trigger selected product detail, related products
    this.sub = this.activatedRoute.params.subscribe(params => {
      console.log("sub",params)
      this.id = params['id'];
      this.getProductdetail();
      // this.getBannerList();
      this.getRelatedProducts();
      this.getProductRatings();

    });
    this.subcribeProductDetails();
    
    // this.getQuestionList();
    console.log('location===>', this.share);
    // this.fileInfos = this.uploadService.getFiles();

  }

  constructImageUrl(containerName: string, image: string): string {
    return `${this.imagePath}?path=${encodeURIComponent(containerName)}&name=${image}`;
  }


  toHTML(input) : any {
    return new DOMParser().parseFromString(input, "text/html").documentElement.textContent;
  }

  
  toggleDivHeight(): void {
    if (this.divHeight === '190px') {
      this.divHeight = '100%';
      this.buttonText = '<< Less';
    } else {
      this.divHeight = '190px';
      this.buttonText = '>> More';
    }
    this.calculateDivHeight();
  }
  calculateDivHeight(): void {
    const divElement = this.el.nativeElement.querySelector('.quick-spec');
    const currentDivHeight = divElement.clientHeight;
    //console.log('currentDivHeight',currentDivHeight)
    //console.log(this.hideMoreButton)
    if(currentDivHeight < 190){
      this.hideMoreButton = false
    }else{
      this.hideMoreButton = true
    }
    // this.hideMoreButton = currentDivHeight <= 190;
    
  }

  sanitizeDescription(description: string): string {
    // Replace <p>&nbsp;</p> with an empty string
    // console.log(description)
    return description.replace(/<p>&nbsp;<\/p>/g, '');
  }
  public subcribeProductDetails() {
    this.optionValueArray = [];
    this.optionNameSelected = [];
    this.subscriptions.push(

      this.productDetail.productDetails$.subscribe(data => {
        console.log('product subscribed', data);
        if (data && Object.keys(data).length) {
          this.optionValueArray = [];
          this.optionNameSelected = [];
          console.log('subscribe 2 times-----');
          this.productDetails = data;
          this.product = data;

          var matchedVarient = this.fullProductCache.productVariantList.filter(f=>f.id == this.currentVarientIndex);
          console.log("Marched Varient =>",matchedVarient)
          if(matchedVarient!=null && matchedVarient.length > 0){
            this.productDetails.productImage = matchedVarient[0].optionImage;
          }

          if(this.productDetails.productImage.length > this.productDetails.productOriginalImage.length )
          {
            // var variant_image = this.productDetails.productImage[0]
            // var selected_variant_image = {}
            
            // this.productDetails.productImage = this.productDetails.productImage.filter((item)=>{
            //   if(item.image != variant_image.image){
            //     return true 
            //   } 
            //   else {
            //     selected_variant_image=item
            //     return false 
            //   }})
            // if(Object.keys(selected_variant_image).length)
            //   this.productDetails.productImage.unshift(selected_variant_image);

            // console.log("main image",this.productDetails.productImage)
            //--- uncomment it  Alex
            //this.productDetails.productImage.shift()

          }


          console.log('----------------product',this.product.Specifications)
          if (this.product.hasTirePrice === 1) {
            if (this.product.productTirePrices.length > 0) {
              this.product.productTirePrices.forEach(each => {
                if (each) {
                  this.tireQuantityArray.push(each.quantity);
                }
              });
            }
          }
          if (this.product.isSimplified === 0) {
            this.generateVariant();
          }
          if (this.product.hasStock === 1) {
            if (this.product.minQuantityAllowedCart > 0) {
              this.quantity = this.product.minQuantityAllowedCart;
              this.tirePriceCalculation();
            }
          }
          if (data.tirePrice !== '') {
            console.log('tire base price in ts', data.tirePrice);
            const tempTirePriceTag = parseFloat(data.tirePrice);
            this.tireBasePrice = tempTirePriceTag;
          } else
          if (data.pricerefer) {
            const tempProductPriceTag = parseFloat(data.pricerefer);
            this.productPriceTag = tempProductPriceTag;
            this.tempPriceRefer = tempProductPriceTag;
            this.templateHidden = this.productPriceTag;
            console.log('price in product details page', this.productPriceTag);
          } else {
            console.log('price in product details else', data.price);
            const tempProductPriceTag = parseFloat(data.price);
            this.productPriceTag = tempProductPriceTag;
            this.tempPriceRefer = tempProductPriceTag;
          }
          setTimeout(() => {
            this.changeDetectRef.detectChanges();
          }, 500);
        }
      })
      );
  }

  changeVariant(event: any) {
    console.log("event",event)
    this.currentVarientIndex = event.varientId;
    this.productDetail.updateProductDetails(event);
    
    console.log('event==>', event);
    console.log('currentVarientIndex==>', this.currentVarientIndex);
    this.quantity = 1;
  }
  searchReviews() {
    this.filteredReviews = this.productRating.filter((review) => {
      return review.review.toLowerCase().includes(this.searchTerm.toLowerCase());
    });
    console.log('filter=======================================>',this.filteredReviews)

    // this.productRating = filteredReviews
  }
  applyElementStyle(){
    //console.log('-------dataPrev',this.techSpec.nativeElement)
    const pNbspElements = this.techSpec.nativeElement.querySelectorAll('p');
    pNbspElements.forEach((p) => {
      if (p.innerHTML === '&nbsp;') {
        p.remove();
      }
    });

    const h4Elements = this.techSpec.nativeElement.querySelectorAll('h4');
    h4Elements.forEach((h4) => {
      const prevElement = h4.previousElementSibling;
      if (prevElement) {
        console.log('-------prev',prevElement)
        prevElement.style.setProperty('border-bottom', 'none', 'important');
      }
    });
  }
  generateVariant() {
    const variantDetails = [];
    if (this.productDetails.productVariant && this.productDetails.productVariant.length > 0) {
      this.productDetails.productVariant.forEach((variant: any) => {
        const temp = variant;
        if (variant.varientsValue && variant.varientsValue.length > 0) {
          const varientsValue = variant.varientsValue.map((result: any) => {
            if (this.checkSelectedVariant(result.id)) {
              result.checked = true;
            } else {
              result.checked = false;
            }
            return result;
          });
          temp.varientsValue = varientsValue;
        }
        variantDetails.push(variant);
      });
    }
    
    this.variantDetails = variantDetails;
    console.log('variantDetails', this.product);
  }

  reviewPopup(){
    const dialogRef = this.dialog.open(ReviewPopupComponent, {
      width: "45%", 
      height:'max-content',
      data:this.productId
    });
  }


  getIntegerPart(value): number {
    return Math.floor(Number(value.toFixed(2)));
  }

  getDecimalPart(data): number {
    const decimalString = data.toFixed(2).split('.')[1];
    return Number(decimalString);
  }
  removeEmptySpace(data:any){
    const emptyParagraphs = data.querySelectorAll('p:empty');
    let modifiedHtml = emptyParagraphs.forEach(paragraph => paragraph.remove());
    console.log(modifiedHtml)

    return modifiedHtml
  }
  checkSelectedVariant(valueId) {
    if (this.productDetails.productVariantDetail && this.productDetails.productVariantDetail.length > 0) {
      const filterValue = this.productDetails.productVariantDetail.filter((result) => result.varientsValueId === valueId);
      if (filterValue && filterValue.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  // calls getRelatedProducts with param
  getRelatedProducts() {
    const params: any = {};
    params.productId = this.id;
    this.productDetail.getRelatedProducts(params);
  }

  // fetch banner list from sandbox
  getBannerList() {
    const params: any = {};
    params.limit = 100;
    params.offset = 0;
    this.productDetail.getBannerList(params);
  }

  // calls getProductRating in sandbox with param
  getProductRatings() {
    const params: any = {};
    params.productId = this.id;
    params.limit = '';
    params.offset = '';
    params.count = '';
    this.ratingArray = []
    this.productDetail.getProductRating(params);
    this.http.get(`http://157.230.179.86:3000/api/product-store/Get-Product-rating?productId=${this.id}&limit=&offset=&count=&selected=3`).subscribe((data:any)=>{
      console.log('rating',data?.data)
      this.productRating = data?.data
      this.ProductRating = data?.data

     this.imageArray = JSON.parse(this.productRating[0].image);
    //  this.ProductRating[0].push(this.imageArray)
      console.log("ratingtesting @@@@@@@",this.imageArray)
      console.log("ratingtesting @@@@@@@",this.ProductRating)
      
      this.productRating.map((rate)=>{
        console.log('rating1',rate)
        this.ratingArray.push(rate?.rating)
        console.log('ratingArray',this.ratingArray)
      })
    })

    
    console.log('ratingArray',this.productRating)



  }
  calculateAverage(numbers: number[]): number {
    if (numbers.length === 0) {
      return 0; // Return 0 if there are no numbers to avoid division by zero.
    }

    const total = numbers.reduce((acc, current) => acc + current, 0);
    return total / numbers.length;
  }

  /**
   * calls productDetail getProductDetails with param.Then subscribe productDetail productDetails$
   *
   * Then store the image path  and image name in the array.
   * **/
  extractFirstSentence(value:any) {
    const sentences = value.split('. ');
    return sentences[0];
  }
  getProductdetail() {
    console.log("testing")

    if(this.id == undefined){
      return
    }
    const params: any = {};
    params.id = this.id;
    params.settingsId = environment.settingsId;
    params.specialdeal = this.splecialDealValue

    this.productDetail.getProductDetails(params);
    
    this.subscriptions.push(
      this.productDetail.productDetails$.subscribe(detail => {
        console.log('product detail--->', detail);
        // console.log("varinatn",detail.productVariantList.varientName) 
        if (detail) {
          this.productId = detail.productId;
        }
        this.fullProductCache = detail;
        
        if (detail && detail.productImage.length > 0) {
          this.video = '';
          
          const imageLength = detail.productImage.length;
          this.isActive = [];
          this.isActive[detail.productImage[0].productId] = true;
          console.log(detail);
          // console.log("check 1 :",detail.productImage[0].productImage);

          var matchedVarient = detail.productVariantList.filter(f=>f.id === this.currentVarientIndex);
         
          console.log("Marched Varient =>",matchedVarient)
          if(matchedVarient!=null && matchedVarient.length > 0){
            detail.productImage = matchedVarient[0].optionImage;
          }
          
          if(detail.productImage.length > detail.productOriginalImage.length )
          {
            // var variant_image = detail.productImage[0]
            // var selected_variant_image = {}


            // detail.productImage = detail.productImage.filter((item)=>{
            //   if(item.image != variant_image.image){
            //     return true 
            //   } 
            //   else {
            //     selected_variant_image=item
            //     return false 
            //   }
            // })
            // if(Object.keys(selected_variant_image).length)
            //   detail.productImage.unshift(selected_variant_image);

            //--- uncomment it  Alex
            //detail.productImage.shift()
            
          }
          

          this.image='';

          this.image =this.imagePath + '?path=' +
          detail.productImage[0].containerName + '&name=' +
          detail.productImage[0].image;
          this.zoomPopupImage = this.image;
          this.zoomImage = '"' + this.imagePath + '?path=' + detail.productImage[0].containerName + '&name=' + detail.productImage[0].image + '"' ;
          
          for (let i = 0; i < imageLength; i++) {
            if (detail.productOriginalImage.length > i && detail.productOriginalImage[i].defaultImage === 1) {
              this.productImageId = detail.productImage[i].productId;
              this.image =
              this.imagePath + '?path=' +
              detail.productImage[i].containerName + '&name=' +
              detail.productImage[i].image ;
              this.zoomPopupImage = this.image;
              this.zoomImage ='"' + this.imagePath + '?path=' +
              detail.productImage[i].containerName + '&name=' +
              detail.productImage[i].image + '"' ;
              // this.changeDetectRef.detectChanges();
              console.log('Inside zoom image', this.zoomImage);
              setTimeout(() => {
                this.config.observer = true;
                this.changeDetectRef.detectChanges();
              }, 500);
            }
          }
        }
        else {
          this.image = "/assets/images/default_image.png";
          setTimeout(() => {
            this.config.observer = true;
            this.changeDetectRef.detectChanges();
          }, 500);
        }
      })
      );
    
    

  }

  ngAfterViewInit() {

    // Use nativeElement to access the DOM elements and apply CSS styles



    this.config = {
      observer: true,
      slidesPerView: 3,
      direction: 'horizontal',
      autoHeight: true,
      autoplay: false,
      spaceBetween: 5,
      keyboard: true,
      navigation: true,
      grabCursor: true,
      pagination: false,
      loop: false,
      preloadImages: false,
      lazy: true,
      watchSlidesVisibility: false,
      breakpoints: {
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3
        }
      }
    };
    this.configuration = {
      observer: true,
      slidesPerView: 3,
      spaceBetween: 15,
      keyboard: true,
      navigation: true,
      grabCursor: true,
      pagination: false,
      loop: false,
      preloadImages: false,
      lazy: true,
      autoplay: false,
      watchSlidesVisibility: true,
      breakpoints: {
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3
        }
      }

    };


  }


  // view the selected image

  public selectImage(image, i) {
    console.log("work");

    this.video = '';
    this.image = '';
    if (i === 'video') {
      var myVideo = document.getElementsByTagName("video")[0];
      this.video = image;
      console.log('videoPlayer-->', myVideo);
      return
    }
    this.productImageId = image.productId;


    this.isActive = [];
    this.isActive[image.productId] = true;
    this.image = this.imagePath + '?path=' + image.containerName + '&name=' + image.image;

    this.changeDetectRef.detectChanges();
    this.zoomPopupImage = this.image;
    this.zoomImage = '"' + this.imagePath + '?path=' + image.containerName + '&name=' + image.image + '"';
    
  }

  // zoom the image when mouse got moved over the image
  public onMouseMove(e) {
    if (window.innerWidth >= 1280) {
      let image, offsetX, offsetY, x, y, zoomer;
      image = e.currentTarget;
      offsetX = e.offsetX;
      offsetY = e.offsetY;
      x = (offsetX / image.offsetWidth) * 100;
      y = (offsetY / image.offsetHeight) * 100;
      if (this.zoomImage) {
        zoomer = this.zoomViewer.nativeElement.children[0];

      }
      if (zoomer) {
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
        zoomer.style.display = 'block';
        zoomer.style.height = image.height + 'px';
        zoomer.style.width = image.width + 'px';
      }
    }
  }

  // event when mouse clicked to zoom the image
  public onMouseLeave(event) {
    this.zoomViewer.nativeElement.children[0].style.display = 'none';
  }

  // open pop to view the zoom image

  // openPreview(index: number,image:any): void {
  //   console.log("testign", image+"length"+index)
    

  //    this.getimage = JSON.parse(image)
  //    console.log("FINAL IMAGE", this.getimage.length)
    
  //   this.images = image
  //   console.log("image ", this.images.length)
  //   this.previewImageIndex = index;
  //   this.previewImageSrc = `${this.imagePath}?path=review/&name=${ this.getimage[index]}`;
  //   this.isPreviewOpen = true;
  // }
  // containerName
  public openZoomViewer(data) {
    this.productlength = data.length
    this.product_image = data[0].image
 
    this.previw_image = `${this.imagePath}?path=review/&name=${ this.productlength[0]}`;
  
    this.isPreviewOpenproduct = true
  }

  openZoomViewerproduct(data) {
    this.containerName = data[0].containerName
    console.log("tewsting", data)
    this.imagesproduct = data;
    this.currentImageIndexproduft = 0;
    this.updatePreviewImage();
    this.isPreviewOpenproduct = true;
  }

  

  changeImageproduct(direction: number) {
    this.currentImageIndexproduft += direction;
    if (this.currentImageIndexproduft < 0) {
      this.currentImageIndexproduft = this.imagesproduct.length - 1;
    } else if (this.currentImageIndexproduft >= this.imagesproduct.length) {
      this.currentImageIndexproduft = 0;
    }
    this.updatePreviewImage();
  }



  updatePreviewImage() {
    this.previw_image =  `${this.imagePath}?path=${this.containerName}/&name=${this.imagesproduct[this.currentImageIndexproduft].image}`;
    // this.previw_image = `${this.imagesproduct[this.currentImageIndexproduft].image}`;
  }


  emptyOutputDecorator(event) {
    if ('clear' === event) {
      this.optionValueArray = [];
      this.optionNameSelected = [];
      // this.totalPrice = 0;
    }
  }

  // get pincode value
  getPincode(val) {
    if (val !== '') {
      this.pinCodeError = false;
    }
    this.checkPinCode = false;
    this.pinCode = Number(val);
  }

  // check product Availbity event
  checkAvailability() {
    // this.checkPinCode = false;
    if (!this.pinCode) {
      console.log('locked');
      this.pinCodeError = true;
      return;
    }
    this.pinCodeError = false;
    this.checkPinCode = true;
    const params: any = {};
    params.pincode = this.pinCode;
    params.productId = this.productId;
    this.productControlSandbox.CheckProductAvailability(params);
  }


  // view tier price chart

  viewTierPriceChart() {
    const dialogRef = this.dialog.open(ViewTierpriceChartComponent, {
      width: '60%',
      data: this.productDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
      }
    });
  }

  makeQuatation(product) {
    const dialogRef = this.dialog.open(MakeQuatationComponent, {
      data: product,
      panelClass: 'make-quotation'

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
      }
    });

  }

  // change quantity of the product
  public changeCount(operation) {
    if (this.product.hasStock === 1) {
      if (operation === 'remove') {
        if (this.quantity > this.product.minQuantityAllowedCart) {
          this.quantity -= 1;
          this.tirePriceCalculation();
        }
      } else if (operation === 'add') {

        if (this.quantity >= this.product.minQuantityAllowedCart && this.quantity < this.product.maxQuantityAllowedCart) {
     // if(this.quantity < this.product.quantity){

          this.quantity += 1;
          this.tirePriceCalculation();
        }
      }
    } else {
      console.log('chnage count is working');
      if (operation === 'remove' && this.quantity > 1) {
        this.quantity -= 1;
        this.tirePriceCalculation();

      } else if (operation === 'add') {
        this.quantity += 1;
        console.log('change count', this.quantity);
        this.tirePriceCalculation();
      }
    }
  }

  getClosest(list, qty) {
    return qty - list.reduce(function (closest, v) {
      return qty >= v.quantity ? Math.min(qty - v.quantity, closest) : closest;
    }, 1e100);
  }

  tirePriceCalculation() {
    if (this.product.hasTirePrice === 1) {
      const minQty = Math.min.apply(Math, this.tireQuantityArray);
      let isMatched = false;
      if (this.quantity >= minQty) {
        this.product.productTirePrices.forEach(data => {
          if (data.quantity === this.quantity) {
            this.tirePrice = data.price;
            const tempTirePriceTag = parseFloat(this.tirePrice);
            this.tireBasePrice = tempTirePriceTag;
            console.log('tire price in detail page', this.tirePrice);
            this.productDetail.changeCount(this.tirePrice);
            isMatched = true;
          }
        });
        if (!isMatched) {
          const result = this.getClosest(this.product.productTirePrices, this.quantity);
          const resultObj = this.product.productTirePrices.find(_list => _list.quantity === result);
          this.tirePrice = resultObj.price;
          const tempTirePriceTag = parseFloat(this.tirePrice);
          this.tireBasePrice = tempTirePriceTag;
          this.productDetail.changeCount(this.tirePrice);
          console.log('closest value', result);
        }

      } else {
        this.tirePrice = '';
        this.productDetail.changeCount(this.tirePrice);
      }
    } else {
      return;
    }
  }


  calculatePrice(amount: number, taxType: number, taxValue: number) {
    const price = +amount;
    switch (taxType) {
    case 1:
      const priceWithOutTax = (+price + this.totalPrice) + taxValue;
      return Math.round(priceWithOutTax);
    case 2:
      const percentToAmount = (+price + this.totalPrice) * (taxValue / 100);
      const priceWithTax = (+price + this.totalPrice) + percentToAmount;
      return Math.round(priceWithTax);
    default:
      return (+price + this.totalPrice);
    }
    // return price;
  }

  CalulateDiscount(amount: number, taxType: number, taxValue: number, Preferamount: number, PrefertaxType: number, PrefertaxValue: number) {
    const price = this.calculatePrice(amount, taxType, taxValue);
    const prefer = this.calculatePrice(Preferamount, PrefertaxType, PrefertaxValue);
    return (price - prefer);
  }

  getOptionTotal(event) {
    this.totalPrice = +event;
    console.log('get option from controls', event);
  }

  getSelectedOptionName(event) {
    this.selectedOptionsName = event;
  }

  getSelectedOptionId(event) {
    this.selectedOptions = event;
  }

  // unsubscribe subscribed events while destroy the page
  ngOnDestroy() {
    this.optionValueArray = [];
    this.sub.unsubscribe();
    this.subscriptions.forEach(each => {
      each.unsubscribe();
    });
  }

  
  window(data) {
    window.open(this.video_url + data, '_blank');
  }

  get previewImageSrc1() {
    return `${this.imagePath}?path=review/&name=${this.imageArray[this.currentIndex]}`;
  }

  openPreview(index: number) {
    this.currentIndex = index;
    this.isPreviewOpen = true;
  }

  closePreview() {
    this.isPreviewOpen = false;
  }

  closePreview2() {
    this.isPreviewOpenproduct = false;
  }

  changeImage(direction: number) {
    this.currentIndex += direction;
    if (this.currentIndex < 0) {
      this.currentIndex = this.imageArray.length - 1;
    } else if (this.currentIndex >= this.imageArray.length) {
      this.currentIndex = 0;
    }
  }

  changeImage2(direction: number) {
    this.currentIndex += direction;
    if (this.currentIndex < 0) {
      this.currentIndex = this.imageArray.length - 1;
    } else if (this.currentIndex >= this.imageArray.length) {
      this.currentIndex = 0;
    }
  }


}
